import { useState } from 'react';
import clsx from 'clsx';
import { AuthSelectProps } from '@/types/props/components/auth';

export default function AuthSelect({
  value,
  onChange,
  name,
  label,
  options,
  defaultOptionText,
}: AuthSelectProps) {
  const [selectOnFocus, setSelectOnFocus] = useState(false);

  return (
    <>
      {Boolean(selectOnFocus || value) && (
        <label
          htmlFor={name}
          className={clsx(
            'tw-absolute -tw-top-3 tw-left-3 tw-z-10 tw-font-plusJakartaSans tw-text-sm tw-font-semibold tw-bg-white',
            {
              ['tw-text-main']: selectOnFocus,
              ['tw-text-[#232323]']: !selectOnFocus && value,
            }
          )}
        >
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        className={clsx(
          'max-sm:tw-text-base tw-w-full tw-border tw-border-solid tw-border-platinum-gray tw-p-4 tw-rounded-xl tw-outline-none focus:tw-border-2 focus:tw-ring-2 tw-font-medium tw-font-plusJakartaSans tw-text-lg tw-leading-[22.68px] tw-text-[#232323] focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500'
        )}
        value={value}
        onChange={onChange}
        onFocus={() => setSelectOnFocus(true)}
        onBlur={() => setSelectOnFocus(false)}
      >
        <option value="" disabled>
          {defaultOptionText}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
}
